import { slRoutes } from "@/lib/slRoutes";

import type { Solution } from "./types";

export type ExpertiseSolutionRaw = {
  title: string;
  description: string;
  /** Resolved at runtime; keys defined in JSON. */
  moreInfoLinkKey?: string;
};

const MORE_INFO_LINKS: Record<string, string> = {
  abfindungAutoindustrie:
    slRoutes.landingpages.arbeitsrecht.abfindungAutoindustrie,
  holdingstrukturen: slRoutes.landingpages.gesellschaftsrecht.holdingstrukturen,
};

export function hydrateExpertiseSolutions(
  record: Record<string, ExpertiseSolutionRaw>,
): Record<string, Solution> {
  const out: Record<string, Solution> = {};
  for (const [key, raw] of Object.entries(record)) {
    const linkKey = raw.moreInfoLinkKey;
    const moreInfoLink =
      linkKey != null && linkKey in MORE_INFO_LINKS
        ? MORE_INFO_LINKS[linkKey]
        : undefined;
    out[key] = {
      title: raw.title,
      description: raw.description,
      moreInfoLink,
    };
  }
  return out;
}
